import { Record } from 'immutable';
import {ReduceStore} from 'flux/utils';
import ActionTypes from '../ActionTypes';
import AppDispatcher from '../AppDispatcher';

const State = new Record({
    centers: null,
    categories: null,
});

class Store extends ReduceStore {
    constructor() {
        super(AppDispatcher);
    }

    getInitialState() {
        return new State();
    }

    reduce(state, action) {
        switch (action.type) {
            case ActionTypes.UPDATE_TOKEN_FAILED:
            case ActionTypes.LOGOUT:
                return state.clear();

            case ActionTypes.SELECT_CENTERS_FINISH:
                return state.set('centers', action.centers);

            case ActionTypes.SELECT_PRODUCT_CATEGORIES_FINISH:
                return state.set('categories', action.categories);

            default:
                return state;
        }
    }
}

export default new Store();




// WEBPACK FOOTER //
// src/stores/RelatorioVendasDosNucleosStore.js